import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-asahi-product',
  imports: [CommonModule,TranslatePipe],
  templateUrl: './asahi-product.component.html',
  styleUrl: './asahi-product.component.scss'
})
export class AsahiProductComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {
    const lang = this.router.url.split('/')[1] || 'vi';
    this.insurances[0].btnLink = `https://lead.livwell.vn/${lang}/car-insurance`;
  }

   /**
   * List of insurance products to display
   */
  insurances = [
 {
    title: 'Car Insurance',
    description: 'Comprehensive protection against accidents and damages. Flexible options to suit your needs',
    btnText: 'BUY NOW',
    btnType: 'primary',
    btnLink: 'https://lead.livwell.vn/vi/car-insurance',
    img: '/png/Car-Small.png',
  },
  {
    title: 'Gymer Insurance',
    description: 'Tailored financial shield for gym accidents & workout medical needs',
    btnText: 'BUY NOW',
    btnType: 'primary',
    btnLink:"https://www.livwell.vn/gym-insurance",
    img: '/png/GYM-PA-Small.png',
  },
  {
    title: 'Personal Accident Insurance',
    description: 'Financial shield for unexpected accidents. Covers treatment & critical support',
    btnText: 'BUY NOW',
    btnType: 'primary',
    btnLink:"https://www.livwell.vn/personal-accident-insurance",
    img: '/png/PA-Small.png',
  }
];
  activeIndex = 0;
  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef<HTMLDivElement>;
  /**
   * Scrolls horizontally to the selected card index
   */
  setActive(index: number) {
    this.activeIndex = index;
    if (this.scrollContainer) {
      const container = this.scrollContainer.nativeElement;
      const cardWidth = container.offsetWidth * 0.8;
      container.scrollTo({
        left: cardWidth * index,
        behavior: 'smooth',
      });
    }
  }

  /**
   * Updates active index based on scroll position (for highlighting dots)
   */
  @HostListener('window:resize')
  ngAfterViewInit() {
    if (this.scrollContainer) {
      this.scrollContainer.nativeElement.addEventListener('scroll', () => this.updateActiveIndex());
    }
  }

  updateActiveIndex() {
    if (!this.scrollContainer) return;
    const container = this.scrollContainer.nativeElement;
    const scrollLeft = container.scrollLeft;
    const cardWidth = container.offsetWidth * 0.8;
    const newIndex = Math.round(scrollLeft / cardWidth);
    if (newIndex !== this.activeIndex) {
      this.activeIndex = newIndex;
    }
  }

}